import stockService from '@services/stock';

import useStockBuySellContext from './useStockBuySellContext';

const useMtCalculation = () => {
  const { code, formState, formKey } = useStockBuySellContext();

  const { isTradeable: isMtTradeable } = stockService.detail.mt.tradeable.useMtTradeable(code);
  const { data: mtTradelimit } = stockService.account.mt.tradelimit.useMtTradelimit({
    code,
    enabled: isMtTradeable, // Only call API when stock is MT tradeable
  });

  const orderTotal = formState[formKey.CALC_ORDER_TOTAL];
  const mtCashMax = (mtTradelimit?.margin_bp || 0) - (mtTradelimit?.margin_available || 0);

  const mtCashUsed = orderTotal > mtCashMax ? mtCashMax : orderTotal;
  const mtLoanUsed = orderTotal > mtCashMax ? orderTotal - mtCashMax : 0;

  return { mtCashUsed, mtLoanUsed };
};

export default useMtCalculation;
